import { Component, OnInit, Inject, PLATFORM_ID, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { isPlatformBrowser } from '@angular/common';
import { QuotationService } from '../../services/quotation.service';
import { HubspotService } from '../../services/hubspot.service';
import { OperatorsService } from '../../services/operators.service';
import { CartService } from '../../services/cart.service';
import { UsersService } from '../../services/users.service';
import { LoginService } from '../../services/login.service';
import { PaginationService } from '../../services/pagination.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { Maker } from '../../constants/maker';
import { Year } from '../../constants/year';
import { Model } from '../../constants/model';
import { Version } from '../../constants/version';
import { Quotation } from '../../constants/quotation';
import { Seller } from '../../constants/seller';

declare var $: any;
import swal from 'sweetalert';
import { environment } from 'src/environments/environment';
declare var OpenPay: any;

@Component({
	selector: 'app-paneluser',
	templateUrl: './paneluser.component.html',
	styleUrls: ['./paneluser.component.scss']
})
export class PaneluserComponent implements OnInit {

	@ViewChild("conektaIframeContainer") conektaIframeContainer: ElementRef;

	user_id: any = "";
	user: any = {
		user: {
			avatar: null,
			first_name: "",
			last_name: "",
			last_name_two: "",
			email: "",
			phone: "",
			password: "",
			password_confirmation: "",
			nip: ""
		},
		personal: {
			street: "",
			ext_number: "",
			int_number: "",
			suburb: "",
			locality: "",
			municipality: "",
			zip_code: "",
			federal_entity: ""
		}
	};
	avatar: any = Array();
	img: any;
	cards: any = Array();
	card_delete: any = Array();
	card_suscription: any = Array();
	subscription_id: any = "";
	policy_id: any = "";
	email_user: any = {
		user_id_old: "",
		user_id_new: "",
		user_email_new: "",
		password: "",
		users: Array()
	}
	card: any = {
		card_number: "",
		holder_name: "",
		expiration_year: "",
		expiration_month: "",
		cvv2: ""
	}
	subscriptions: any = Array();
	policies: any = Array();
	policies_subscriptions: any = Array();
	boolean: any = false;
	seller: any;
	constructor(@Inject(PLATFORM_ID) private platformId: Object, private route: ActivatedRoute, private location: Location, private router: Router, private quotationService: QuotationService, private hubspotService: HubspotService, private operatorsService: OperatorsService, private spinner: NgxSpinnerService, private paginationService: PaginationService, private userService: UsersService, private cartService: CartService, private loginService: LoginService,
		private renderer: Renderer2) { }
	ngOnInit() {

		// this.chargeIFrameConekta()

		this.seller = this.loginService.getSession();
		this.user_id = this.route.snapshot.params['user_id'];
		this.email_user.user_id_old = this.user_id;
		this.userService.getEditableInfo(this.user_id)
			.subscribe((data: any) => {
				if (data.result) {
					this.user = {
						user: {
							avatar: null,
							first_name: data.data.user.first_name,
							last_name: data.data.user.last_name,
							last_name_two: data.data.user.last_name_two,
							email: data.data.user.email,
							phone: data.data.user.phone,
							password: null,
							password_confirmation: null,
							nip: null
						},
						personal: {
							street: data.data.personal.street,
							ext_number: data.data.personal.ext_number,
							int_number: data.data.personal.int_number,
							suburb: data.data.personal.suburb,
							locality: data.data.personal.locality,
							municipality: data.data.personal.municipality,
							zip_code: data.data.personal.zip_code,
							federal_entity: data.data.personal.federal_entity
						}
					}

					this.avatar = data.data.user.avatar;

					console.log(data);
				}
			})
		this.getCards();
		this.getPolicies();
		this.userService.getSubscriptions(this.user_id)
			.subscribe((data: any) => {
				if (data.result) {
					this.subscriptions = data.subscriptions;
				}
			});


	}


	chargeIFrameConekta() {

		this.renderer.setProperty(this.conektaIframeContainer.nativeElement, 'innerHTML', '')

		this.cartService.getTokenConekta().subscribe((resp: any) => {
			console.log(resp)

			window.ConektaCheckoutComponents.Card({
				targetIFrame: "#conektaIframeContainer",
				allowTokenization: true,
				checkoutRequestId: resp.checkout.id,
				publicKey: environment.apiKeyConkecta,
				locale: 'es',
				options: {
					// theme: 'green',
					styles: {
						colors: {
							primary: '#0f312a'
						},
						inputType: 'basic',
						buttonType: 'basic',
						states: {
							empty: {
								borderColor: '#0f312a'
							},
							invalid: {
								borderColor: '#F95234'
							},
							valid: {
								borderColor: '#0f312a'
							}
						}
					},
					button: {
						colorText: '#ffffff',
						text: 'Guardar tarjeta',
						backgroundColor: '#0f312a',
					},
					iframe: {
						colorText: '##495057',
						backgroundColor: '#FFFFFF'
					}
				},
				onCreateTokenSucceeded: this.createCard.bind(this),
				onCreateTokenError: function (response) {
					console.error("Error create token", response)
				}

			})
		}, error => {
			console.error(error)
		})
	}


	onSubmit() {
		console.log(this.user);
		this.spinner.show();
		this.userService.updateUserInfo(this.user_id, this.user)
			.subscribe((data: any) => {
				console.log(data);
				this.spinner.hide();
				if (data.result) {
					this.user.user.password = null;
					this.user.user.password_confirmation = null;
					this.user.user.nip = null;
					swal("La información se ha guardado exitosamente", "", "success");
				}
				else swal("No se pudo guardar la información", "", "error")
			})
	}
	getPolicies() {
		this.userService.getPoliciesByIdUser(this.user_id)
			.subscribe((data: any) => {
				if (data.result) {
					this.policies = data.data;
				}
			});
	}
	getCards() {
		this.userService.getCards(this.user_id)
			.subscribe((data: any) => {
				console.log(data);
				if (data.result) {
					this.cards = data.cards;
				}
			});
	}

	changeEmail() {
		console.log(this.email_user);
		this.operatorsService.validatePassword(this.seller.id, this.email_user.password)
			.subscribe((data: any) => {
				console.log(data);
				if (data.result) {
					if (this.email_user.user_id_new == "") {
						this.email_user.user = Array();
						this.operatorsService.validateUser(this.email_user.user_email_new)
							.subscribe((data2: any) => {
								console.log(data2);
								if (data2.result) {
									this.email_user.users = data2.data;
									swal("El correo  ya existe", "Selecciona el correo de usuario existente", "warning");
								}
								else {
									this.sendChangeEmail();
								}
							});
					}
					else {
						console.log("ID USUARIO SUBSCRIPTIONS")
						console.log(this.email_user.user_id_old);
						this.userService.getSubscriptions(this.email_user.user_id_old)
							.subscribe((data2: any) => {
								console.log(data2);
								if (data2.result) {
									if (data2.subscriptions.length > 0) {
										let msg = data2.subscriptions.length + " suscripción";
										if (data2.subscriptions.length > 1)
											msg = data2.subscriptions.length + " suscripciones";

										swal("El usuario tiene " + msg, "¿Estás seguro que deseas cambiar de usuario?\nSi cambias de usuario, las suscripciones se cancelarán", {
											buttons: ["Cancelar", "Aceptar"],
										})
											.then((value) => {
												if (value) {
													data2.subscriptions.forEach(element => {
														console.log("Poliza a cancelar: " + element.id)
													});
													this.sendChangeEmail();
												}
											})
									}
									else {
										this.sendChangeEmail();
									}
								}
							});
					}

				}
				else swal("Hubo un problema", "La contraseña es incorrecta", "error");
			});

	}
	sendChangeEmail() {
		let user = {
			new_user_id: this.email_user.user_id_new,
			email: this.email_user.user_email_new,
			policy_id: null
		}
		if (this.email_user.user_id_new != "") {
			user.email = null;
		}
		console.log(this.email_user);
		console.log(user);
		this.operatorsService.changeUserEmail(this.user_id, user)
			.subscribe((data: any) => {
				console.log(data);
				$("#modalChangeUser").modal("hide");
				if (data.result) {
					swal("Se ha cambiado correctamente el correo de la póliza", "", "success");
					this.router.navigate(['/panel/user/' + data.data.user.id]);
				}
				else swal("Hubo un problema", "No se pudo cambiar el correo", "error");
			})


	}

	changePassword() {
		if (this.user.user.password != this.user.user.password_confirmation) {
			swal("No se pudo cambiar la contraseña", "No coinciden las contraseñas, inténtalo de nuevo", "error");
			this.user.user.password = null;
			this.user.user.password_confirmation = null;
		}
		else {
			$("#modalPassword").modal("hide");
			this.onSubmit();
		}
	}

	changeNip() {
		$("#modalNip").modal("hide");
		this.onSubmit();
	}

	changeAvatar(files: FileList) {
		console.log(files);
	}
	changeListener($event): void {
		this.readThis($event.target);
	}

	readThis(inputValue: any): void {
		var file: File = inputValue.files[0];
		var myReader: FileReader = new FileReader();

		myReader.onloadend = (e) => {
			let img: any = myReader.result;
			let ext: any = "";

			this.img = img.split("base64,");
			ext = this.img[0].split("image/");

			this.user.user.avatar = {
				data: this.img[1],
				ext: ext[1].slice(0, -1)
			}
		}
		myReader.readAsDataURL(file);

		//console.log(myReader);
	}

	setCardDelete(card) {
		this.card_delete = card;
	}
	deleteCard() {
		let i = 0;
		$("#modalDeleteCard").modal("hide");
		this.userService.deleteCard(this.card_delete.id)
			.subscribe((data: any) => {
				console.log(data)
				if (data.result) {
					this.cards.forEach(
						item => {
							if (item.id == this.card_delete.id) {
								if (this.cards.splice(i, 1))
									swal("La tarjeta se ha eliminado correctamente", "", "success")
							}
							i++;
						}
					)
				}
				else swal("Hubo un problema", data.msg, "error")
			})
	}
	setCardSuscription(tipo, card) {
		this.card_suscription = card;
		this.subscription_id = "";
		this.policy_id = "";
		this.policies_subscriptions = Array();
		this.boolean = false;
		console.log("Tarjeta:")
		console.log(card);
		//console.log();

		if (tipo == 'cancelar') {
			this.userService.getCard(card.id)
				.subscribe((data: any) => {
					console.log(data)
				})
		}
	}

	cancelSubscription() {
		console.log("ID: " + this.subscription_id)
		console.log(this.card_suscription);
		$("#modalCancelSuscription").modal("hide");
		this.userService.deleteSubscriptions(this.subscription_id)
			.subscribe((data: any) => {
				console.log(data);
				if (data.result) {
					this.userService.getCards(this.user_id)
						.subscribe((data2: any) => {
							if (data) {
								swal("Se ha cancelado suscripción correctamente", "", "success");
							}
							if (data2.result) {
								this.subscriptions = data2.subscriptions;
							}
						});
				}
				else {
					swal("Hubo un problema", "No se pudo cancelar la suscripción", "error");
				}
			})
	}
	createSubscription() {
		let subscription = {
			user_id: +this.user_id,
			policy_id: +this.policy_id,
			card_id: +this.card_suscription.id
		}
		console.log(subscription);
		$("#modalCreateSubscription").modal("hide");
		this.userService.createSubscriptions(subscription)
			.subscribe((data: any) => {
				console.log(data);
				if (data.result) {
					if (data.subscription.active) {
						this.subscriptions.push(data.subscription)
						swal("Se ha creado la suscripción correctamente", "", "success");
					}
				}
				else {
					swal("Hubo un problema", "No se pudo crear la suscripción", "error");
				}
			})
	}

	createCard(token?: any) {
		let card: any = {
			user_id: this.user_id,
			token: token.id,
			device_session_id: "",
			full_name: `${this.user.user.first_name} ${this.user.user.last_name} ${this.user.user.last_name_two}`,
			phone: this.user.user.phone ? this.user.user.phone : '',
		}

		this.operatorsService.createCard(card)
			.subscribe((data: any) => {
				// console.log(data);
				if (data.result) {
					this.cards.push(data.card)
				}
				swal("La tarjeta se ha agregado correctamente", "", "success")
				$("#modalCreateCard").modal("hide");
			}, () => {
				swal("Hubo un problema", "No se pudo guardar la tarjeta", "error")
			})

	}

}
